import * as React from "react";

import {
  getPhotoSetStatusIcon,
  getPhotoSetStatusTypeI18nKey,
  getPhotoSetStatusTypeStyle,
  PhotoSetStatus,
} from "../../troubleshoot/ReportTroubleshoot";
import ReportStatusUtils from "../../reports/ReportStatusUtils";

interface PhotoSetStatusViewerProps {
  status: PhotoSetStatus;
  className?: string;
  detail?: string;
  displayAllRejectionCauses: boolean;
}

// LongTermFix 18/02/2020 aledref: should be refactored with StatusViewer to take into props style, icon an i18n key direclty
export default function PhotoSetStatusViewer(props: PhotoSetStatusViewerProps) {
  const detail =
    i18n[ReportStatusUtils.getRejectionCauseI18nKey(props.detail)] ||
    (props.displayAllRejectionCauses ? props.detail : "");

  return (
    <div
      className={`status-viewer ${getPhotoSetStatusTypeStyle(
        props.status
      )}${props.className ? " " + props.className : ""}`}
    >
      <i className={getPhotoSetStatusIcon(props.status)} />
      <span>
        {i18n[getPhotoSetStatusTypeI18nKey(props.status)]}
        {detail && `: ${detail}`}
      </span>
    </div>
  );
}
